import React from "react";
import AButton from "../../../../../views/pages/manage/common/form-fields-mui/AButton";
import { getFormattedAmount } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const BulkActionBar = ({
  count,
  totalAmount,
  onProceed,
  depositForm,
  onViewDeposit,
  onSendForApproval,
  isApiCalling,
}) => {
  const style = count === 0 ? { background: "#757575" } : {};
  return (
    <div className="cm-bulk-bar" style={style}>
      <div className="cm-bulk-info">
        {count === 0
          ? "Select cheques to deposit"
          : `${count} Cheques selected • ${getFormattedAmount(totalAmount)}`}
      </div>
      <div>
        <AButton
          disabled={count === 0}
          variant="primary_filled"
          className="btn btn-primary"
          onClick={onProceed}
        >
          Proceed to deposit cheques
        </AButton>
      </div>
    </div>
  );
};

export default BulkActionBar;
